import React from "react";
import { connect } from "react-redux";
import { getBrand } from "../brand/brand-selectors";

function AppBackground({ brand }) {
  return (
    brand.appBackground && (
      <div
        className="Background App__Background"
        style={
          brand.appBackground.url
            ? { backgroundImage: `url(${brand.appBackground.url})` }
            : {}
        }
      >
        <div
          className="App__BackgroundOverlay"
          style={brand.appBackground.overlayStyle}
        />
      </div>
    )
  );
}

AppBackground = connect(state => ({
  brand: getBrand(state)
}))(AppBackground);

export default AppBackground;



// WEBPACK FOOTER //
// ./src/modules/root/app-background.js